export const TRACKING_CHANNEL = 'wbm/People_Directory';
export const USER_BAG_FILTERS_ID = {
  city: 'city',
  jobTitle: 'jobTitle',
};

const LETTER_OR_MISC_REGEX = 'misc|[a-z]{1}';
const PEOPLE_DIRECTORY_ROUTE = `/people/`;
const SLUG_REGEX = ':slug([a-zA-Z]+-[a-zA-Z]+)';
const SLUG_PAGE_REGEX = '-p:page([0-9]+)';
const COUNTRY_REGEX = '[a-z]{0,2}';

export const userBagCityRoutes = {
  LETTER_PAGE: `${PEOPLE_DIRECTORY_ROUTE}:letter(${LETTER_OR_MISC_REGEX})/`,
  CITY_PAGE: `${PEOPLE_DIRECTORY_ROUTE}cities/:country(${COUNTRY_REGEX})/:city/`,
  USER_BAG_PAGE: `${PEOPLE_DIRECTORY_ROUTE}cities/:country(${COUNTRY_REGEX})/:city/${SLUG_REGEX}/`,
  USER_BAG_PAGE_PAGINATED: `${PEOPLE_DIRECTORY_ROUTE}cities/:country(${COUNTRY_REGEX})/:city/${SLUG_REGEX}${SLUG_PAGE_REGEX}/`,
};

export const SEO_URL_META_DATA = 'https://www.xing.com/people/';
